import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { CallInfo } from './dump/CallInfo';
import * as React from 'react';
import { UIHeading3 } from '@cian/ui-kit/typography';
import { getPhoneData } from '../../utils/getPhoneData';
import * as styles from './InfosPopupContent.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var InfosPopupContent = function InfosPopupContent(_ref) {
  var builders = _ref.builders,
    sellers = _ref.sellers,
    httpApi = _ref.httpApi,
    logger = _ref.logger,
    pageType = _ref.pageType,
    platformType = _ref.platformType,
    placeType = _ref.placeType,
    onPhoneOpen = _ref.onPhoneOpen,
    openContactsSellerPhoneStyles = _ref.openContactsSellerPhoneStyles,
    openContactsBuilderPhoneStyles = _ref.openContactsBuilderPhoneStyles;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(UIHeading3, {
      children: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u044B"
    }), builders.map(function (builder) {
      return /*#__PURE__*/_jsx("div", {
        className: styles['item'],
        children: /*#__PURE__*/_jsx(CallInfo, _objectSpread(_objectSpread({}, getPhoneData({
          data: builder,
          isBuilder: true,
          button: openContactsBuilderPhoneStyles
        })), {}, {
          httpApi: httpApi,
          logger: logger,
          pageType: pageType,
          platformType: platformType,
          placeType: placeType,
          onPhoneOpen: onPhoneOpen
        }))
      }, builder.id);
    }), sellers.map(function (seller) {
      return /*#__PURE__*/_jsx("div", {
        className: styles['item'],
        children: /*#__PURE__*/_jsx(CallInfo, _objectSpread(_objectSpread({}, getPhoneData({
          data: seller,
          isBuilder: false,
          button: openContactsSellerPhoneStyles
        })), {}, {
          httpApi: httpApi,
          logger: logger,
          pageType: pageType,
          platformType: platformType,
          placeType: placeType,
          onPhoneOpen: onPhoneOpen
        }))
      }, seller.realtyUserId);
    })]
  });
};